<ion-grid class="info-panel step-2--defect">
  <ion-card
    class="wrapper wrapper--preliminary info-panel__card info-panel__card--first"
  >
    <app-preliminary-difference
      [preliminaryDifferenceAgreement]="preliminaryDifferenceAgreement"
      [isReadonly]="isReadonly"
    ></app-preliminary-difference>

    <ion-row>
      <ion-col>
        <ion-list lines="none" data-test="differences">
          <app-time-input
            *ngFor="let differenceInput of differenceInputs; first as isFirst"
            [data]="differenceInput"
            [timeInputClass]="differenceInput.class"
            [initialValues]="getTimeInputInitialValues(differenceInput)"
            (changeTime)="onDifferenceTimeChange($event, differenceInput.type)"
            class="time-input"
            [class.time-input--first]="isFirst"
            [isBBVACompany]="isBBVACompany()"
            [isReadOnly]="isReadonly"
          ></app-time-input>

          <ion-row
            *ngIf="shouldBeReasoned()"
            class="ion-justify-content-center ion-align-items-center time-input"
          >
            <ion-col size="cover" class="col">
              <b>
                {{ 'WORKING_DAY.STEP_2.ABSENCE_REASON.TITLE' | translate }}
              </b>
            </ion-col>

            <ion-col class="absence-col">
              <button
                type="button"
                class="fake-select"
                [class.disabled]="disableAbsenceButton"
                [disabled]="disableAbsenceButton"
                (click)="openAbsencePopover($event)"
              >
                <span class="value">
                  {{
                    selectedEqualityPlan?.name ||
                      ('WORKING_DAY.STEP_2.ABSENCE_REASON.SELECT' | translate)
                  }}
                </span>
                <ion-icon name="chevron-down-outline"></ion-icon>
              </button>

              <ion-popover
                #absencePopover
                [isOpen]="absencePopoverOpen"
                [event]="absencePopoverEvent"
                side="bottom"
                alignment="center"
                [showBackdrop]="true"
                [keyboardClose]="true"
                (didDismiss)="absencePopoverOpen = false"
              >
                <ng-template>
                  <ion-list class="popover-list">
                    <ion-radio-group [(ngModel)]="equalityPlanKey">
                      <ion-item
                        *ngFor="let specialAbsence of specialAbsences"
                        button
                        detail="false"
                        (click)="selectAbsenceReason(specialAbsence)"
                      >
                        <ion-label>
                          {{ specialAbsence.name }}
                        </ion-label>

                        <ion-radio
                          slot="end"
                          [value]="specialAbsence.key"
                        ></ion-radio>
                      </ion-item>
                    </ion-radio-group>
                  </ion-list>
                </ng-template>
              </ion-popover>
            </ion-col>
          </ion-row>

          <ion-item *ngIf="!isReadonly">
            <ion-label class="time-total">
              <span>
                {{ 'WORKING_DAY.STEP_2.DIFFERENCE_INPUT.TOTAL' | translate }}
              </span>
              <span class="time-total__value">
                {{ sumDifferences() | humanizeDuration }}
              </span>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-card>

  <app-effective-working-time
    [effectiveWorkingTime]="effectiveWorkingTime"
    [isReadonly]="isReadonly"
    [isDisabled]="!canContinue()"
    (confirmSend)="send()"
  ></app-effective-working-time>
</ion-grid>
